<template>
	<div class="job-vita--grid-area-section">
		<div>{{ section.title }}:</div>
		<div>
			<div v-if="section.matching" class="job-vita--grid-area-section-matching-icon">
				<Icon :icon="matchingIcon.icon" :color="matchingIcon.color"/>
			</div>
			<div v-if="section.predefinedValue">
				<PredefinedValue :predefined-value="section.predefinedValue"/>
			</div>
			<div v-else-if="section.text" v-html="section.text"/>
			<template v-else>
				<application-job-vita-grid-area-section-item
					v-for="item in filteredItems"
					:key="item.id"
					:item="item"
					:job-profile-id="jobProfileId"
					:pseudonym-id="pseudonymId"
					@upgrade="onUpgrade"
				/>
			</template>
			<div v-if="section.furtherItemsCount" class="color-green mt-1">
				<template v-if="section.furtherItemsCountText">{{ section.furtherItemsCountText }}</template>
				<template v-else>Die Person hat bisher mehr als {{ furtherItemsCountCapped }} weitere
					{{ section.furtherItemsCountLabel }} gesammelt.
				</template>
				<br/>Kontaktiere sie, um mehr darüber zu erfahren.
			</div>
			<div v-if="section.extraPayload && section.extraPayload.type === 'salary'" class="pl-2">
				In Österreich ist es verpflichtend in Stellenausschreibungen das laut Kollektivvertrag
				vorgesehene Mindestgehalt anzugeben, welches du
				<a href="#" target="_blank" @click.prevent="showCollectiveSalary = true">hier</a> findest.
				Achtung: das angebotene Gehalt liegt darüber.
			</div>
			<!-- 2025-01: not needed right now -->
			<!--<div v-if="section.needsUpgrade">
				<Button
					text="Details"
					secondary
					smaller
					@click="showUpgradePopUp = true"
				/>
			</div>-->
		</div>
		<PopUp
			v-if="showCollectiveSalary"
			title="Gehalt laut Kollektivvertrag"
			ok-text="OK"
			hide-cancel
			@ok="showCollectiveSalary = false"
			@hidden="showCollectiveSalary = false"
		>
			Das Mindestgehalt laut Kollektivvertrag/Tarif beträgt auf Basis Vollzeit
			{{ section.extraPayload.collective | moneyAmount }}.<br/><br/>
			Natürlich kann je nach Qualifikation und Möglichkeit im Unternehmen ein höheres Gehalt vereinbart werden.
		</PopUp>
		<UpgradePopUp
			v-if="showUpgradePopUp"
			:job-profile-id="jobProfileId"
			:pseudonym-id="pseudonymId"
			@upgrade="onUpgrade"
			@hidden="showUpgradePopUp = false"
		/>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import UpgradePopUp from "@/vue/permission/UpgradePopUp";
import PredefinedValue from "@/vue/application/job/vita/grid/PredefinedValue";
import Matching from "./Matching"
import Icon from "@/vue/icon/Icon.vue";
import PopUp from "@/vue/common/PopUp.vue";

export default {

	components: {
		PopUp,
		Icon,
		PredefinedValue,
		Button,
		UpgradePopUp,
		Matching,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		pseudonymId: {
			type: String,
			required: false,
		},
		section: {
			type: Object,
			required: true,
		}
	},

	data ()
	{
		return {
			showUpgradePopUp: false,
			showCollectiveSalary: false
		};
	},

	computed: {
		furtherItemsCountCapped ()
		{
			const furtherItemsCount = this.section.furtherItemsCount ?? 0;

			return furtherItemsCount > 5
				? 5
				: furtherItemsCount;
		},
		matchingIcon ()
		{
			if (!this.section.matching)
			{
				return null;
			}

			if (!this.section.matching.match)
			{
				return {
					icon: 'close',
					color: 'red'
				};
			}

			if (this.section.matching.fullMatch !== null)
			{
				return {
					icon: this.section.matching.fullMatch ? 'checkmark' : 'tilde',
					color: this.section.matching.fullMatch ? 'green' : 'gold'
				};
			}

			return {
				icon: 'checkmark',
				color: 'green'
			};
		},
		filteredItems ()
		{
			let items = this.section.items;

			if (this.section.showOnlyItemsNecessaryForJobProfile)
			{
				items = items.filter(item => item.necessaryForJobProfile);
			}

			return items;
		}
	},

	methods: {
		onUpgrade ()
		{
			this.showUpgradePopUp = false;

			this.$emit('upgrade');
		}
	}
}
</script>
